import { priceFields } from '../config/settings.js';

const { InvData, scrollToAnchor } = window.DDC;

// Scroll the browser to the top of the search results.
const scrollToListings = () => {
	if (jQuery) {
		scrollToAnchor(jQuery('[data-widget-id="inventory-results1"]'), {
			heightAdj: document.querySelector('.page-header').scrollHeight + 25
		});
	}
}

// Get the price field used by the SRP for filtering purposes.
const getPriceField = (priceFieldOverride) => {
	if (priceFieldOverride.length > 0 && priceFieldOverride[0].length > 0) {
		return priceFieldOverride[0];
	}

	const facetList = document.querySelector('#facet-list');
	const facetGroups = facetList.querySelectorAll('.facet-list-group');

	let chosenField;

	facetGroups.forEach(group => {
		if (chosenField) {
			return;
		}
		const fieldId = group.getAttribute('id');
		if (priceFields.includes(fieldId)) {
			chosenField = fieldId;
		}
	});

	if (!chosenField) {
		[ chosenField ] = priceFields;
	}

	return chosenField;
}

// Actually set the filters for the SRP widget
const setPricingFilters = (data, priceField) => {
	if (data.budget > 0) {
		const budgetUpper = parseInt(data.budget, 10);
		const budgetRange = `1-${budgetUpper}`;

		let priceAlreadySet = false;

		InvData.appliedFilters.map(item => {
			if (item && item.values.length > 0 && item.values[0].value === budgetRange) {
				priceAlreadySet = true;
			}
			return true;
		});

		if (priceAlreadySet) {
			return;
		}

		// Filter the SRP inventory according to the user's budget.
		InvData.setFilterSelections({
			filterName: priceField,
			filterValues: [budgetRange],
			element: null,
			isSelected: false,
			isSlider: true,
			isChip: false
		});
	}
}

// Filter the SRP to the user's budget
export const filterSRP = (data, inventoryPriceField) => {
	const priceField = getPriceField(inventoryPriceField);
	setPricingFilters(data, priceField);
	scrollToListings();
}
